var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeadline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m451 91v300h-451v-300l34.898438-31h389.703124zm0 0",
    fill: "#ececf1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m451 91v300h-225v-331h198.601562zm0 0",
    fill: "#dadae0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31 0h30v45h-30zm0 0",
    fill: "#3e5959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m121 0h30v45h-30zm0 0",
    fill: "#3e5959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m301 0h30v45h-30zm0 0",
    fill: "#384949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m211 0h30v45h-30zm0 0",
    fill: "#3e5959"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m391 0h30v45h-30zm0 0",
    fill: "#384949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m226 0h15v45h-15zm0 0",
    fill: "#384949"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m0 30h451v61h-451zm0 0",
    fill: "#ff7816"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m226 30h225v61h-225zm0 0",
    fill: "#ff4b00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m61 151h60v30h-60zm0 0",
    fill: "#76e2f8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m151 151h60v30h-60zm0 0",
    fill: "#76e2f8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m241 151h60v30h-60zm0 0",
    fill: "#25d9f8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m331 151h60v30h-60zm0 0",
    fill: "#25d9f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#76e2f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61 211h60v30h-60zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 211h60v30h-60zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 271h60v30h-60zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 271h60v30h-60zm0 0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m241 211h60v30h-60zm0 0",
    fill: "#25d9f8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m376 241c-74.398438 0-135 60.597656-135 135 0 74.398438 60.601562 136 135 136s136-61.601562 136-136c0-74.402344-61.601562-135-136-135zm0 0",
    fill: "#ff7816"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m512 376c0 74.398438-61.601562 136-136 136v-271c74.398438 0 136 60.597656 136 135zm0 0",
    fill: "#ff4b00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m361 421h30v30h-30zm0 0",
    fill: "#3e5959"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m361 301h30v90h-30zm0 0",
    fill: "#3e5959"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m376 301h15v90h-15zm0 0",
    fill: "#384949"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m376 421h15v30h-15zm0 0",
    fill: "#384949"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadline);
export default __webpack_public_path__ + "static/media/deadline.d173ea74.svg";
export { ForwardRef as ReactComponent };